import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConfirmDialogComponent} from '../../../../common/dialogs/confirm-dialag/confirm-dialag.component';
import {MatDialog} from '@angular/material';

@Component({
  selector: 'app-delete-button',
  template: `
    <a class="table-link danger app-pointer"
       [ngClass]="[disabled?'disabled':'']"
       (click)="deleteEvent($event)" tabindex="-1"
    >
      <span class="fa-stack"><i class="fa fa-square fa-stack-2x"></i><i class="fa fa-trash-o fa-stack-1x fa-inverse"></i></span>
    </a>
  `
})

export class DeleteButtonComponent implements OnInit {

  @Input() disabled: boolean;
  @Input() confirm: boolean;
  @Input() confirmMessage: String = 'Вы действительно хотите удалить?';
  @Input() title: String;

  @Output() onClick = new EventEmitter<any>();

  constructor(private _dialog: MatDialog) {

  }

  ngOnInit() {
  }

  deleteEvent(event) {
    if (this.disabled) {
      return;
    }

    if (!this.confirm) {
      this.onClick.emit(event);
    } else {
      this._dialog.closeAll();
      const dialogRef = this._dialog.open(ConfirmDialogComponent, {
        maxWidth: '45%',
        data: {
          message: this.confirmMessage
        }
      });

      dialogRef.afterClosed().subscribe(
        (result) => {
          if (result) {
            this.onClick.emit(event);
          }
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/delete-button/delete-button.component.ts